/*
 * @Author: why
 * @Date: 2019-08-08 19:33:44
 * @LastEditors: why
 * @LastEditTime: 2019-09-09 15:02:54
 * @Description: 
 */
import api from './extend';

export default api;